import { render } from "./PillSelect.vue?vue&type=template&id=7fd66350&scoped=true"
import script from "./PillSelect.vue?vue&type=script&lang=js"
export * from "./PillSelect.vue?vue&type=script&lang=js"

import "./PillSelect.vue?vue&type=style&index=0&id=7fd66350&lang=sass&scoped=true"

import exportComponent from "/home/ploi/orthomatrix.orthosol.com/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7fd66350"]])

export default __exports__